﻿import * as Model from '../../models/models';

export class SearchViewModel {

    submissions: Array<Model.ISubmission>;
    policyholderusers: Array<Model.IPolicyholderUser>;
    users: Array<Model.IUserProfile>;
    controllingTaxAddresses: Array<Model.IAddress>;
    searchResults: Array<SearchResultModel>;
    submissionStatusCodes: Array<Model.ICode>;

}

export class SearchResultModel {

    submissionId: string;
    policyholderId: string;
    userId:string;
    controllingTaxAddressId: string;
    controllingTaxAddress:Model.IAddress;
    firstName: string;
    lastName: string;
    organizationName: string;
    legalBusinessName:string;
    policyEffectiveDate: Date;
    policyExpirationDate: Date;
    get fullName(): string {return !this.firstName ? "" : this.firstName + " " + this.lastName;}
    submissionStatusDescription: string;
    underwritingOverride: boolean;
    
}